export default __webpack_public_path__ + "images/crash_face-b2l2zId.svg";